import { render } from "./simpeg-pegawai-add-backup.vue?vue&type=template&id=10e11363"
import script from "./simpeg-pegawai-add-backup.vue?vue&type=script&lang=js"
export * from "./simpeg-pegawai-add-backup.vue?vue&type=script&lang=js"

import "./simpeg-pegawai-add-backup.vue?vue&type=style&index=0&id=10e11363&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__